module.exports = __webpack_public_path__ + "assets/img/high.9f661a72.png";